import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../../shared/routing/appPaths";
import StatusMessage from "../../../ui/feedback/StatusMessage";
import type { StepSave } from "./changeSetStep";

/**
 * What a save did, after every editor's save (ADR-0031 D2): an edit is reviewed in its step's
 * Thread, the one shown (`shownIn`) or the one its save started; a change set saved outside an
 * edit step is reviewed on its own.
 */
export default function StepSaveNotice({ saved, shownIn }: { saved: StepSave; shownIn: string | null }) {
  const { t } = useTranslation();
  if (saved.kind === "nothingToChange") return <StatusMessage tone="info">{t("authoring.changeSet.nothingToChange")}</StatusMessage>;
  return (
    <StatusMessage tone="success" title={t("authoring.changeSet.added")}>
      {saved.kind === "committed" ? (
        <Link to={appPaths.review(saved.changeSetId)} className="app-link underline">{t("authoring.changeSet.openReview")}</Link>
      ) : saved.threadId === shownIn ? (
        <p>{t("authoring.changeSet.reviewedHere")}</p>
      ) : (
        <Link to={appPaths.thread(saved.threadId)} className="app-link underline">{t("authoring.changeSet.openThread")}</Link>
      )}
    </StatusMessage>
  );
}
